'use strict';

/**
 * Builds the patchAttributes payload sent when an admin saves a user on the
 * "view user" screen (Area #12): firstName/lastName/email plus the
 * per-subaccount `permissions` map and the account-wide `isAccountAdmin`
 * flag. Extracted as a plain function (no angular-mocks) following the
 * edit-app-connect.js / save-force-emit.js precedent so the payload shape
 * is directly testable.
 */
function buildUserSavePayload(user) {
    return {
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email.toLowerCase(),
        permissions: user.permissions,
        isAccountAdmin: user.isAccountAdmin,
    };
}

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = {
        buildUserSavePayload: buildUserSavePayload,
    };
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('viewUserSave', {
        buildUserSavePayload: buildUserSavePayload,
    });
}
